import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetForm } from '../hooks/useGetForm';
import { usePageMetadata } from '../hooks/usePageMetadata';
import { WalletInscriptionPage } from './WalletInscriptionPage';
import { ConfirmationPage } from './ConfirmationPage';
import { ErrorPage } from '../components/ErrorPage';
import { Loader } from '../components/ui/loader';
import { FormType } from '../enums/form-type.enum';
import { InscriptionPage } from './InscriptionPage';

export const WalletFormPage: React.FC = () => {
  const { form } = useParams<{ form: string; wallet: string }>();
  
  // Usar el formId para obtener la configuración
  const { data: formConfig, isLoading, error } = useGetForm(form || '');
  
  usePageMetadata(formConfig);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader size="lg" id={form!} />
      </div>
    );
  }

  if (error || !formConfig) {
    return (
      <ErrorPage 
        error="No se pudo cargar el formulario."
        statusCode={404}
      />
    );
  }

  const formType = formConfig.type;

  // Determinar qué componente mostrar basado en el tipo
  switch (formType) {
    case FormType.CONFIRMATION:
      return <ConfirmationPage />;
    
    case FormType.INCREMENTAL:
    case FormType.REGISTRATION:
      return <WalletInscriptionPage />;
    case FormType.INSCRIPTION:
      return <InscriptionPage />;
    default:
      return <InscriptionPage />;
  }
};
